import '../styles/settings.css';

const ImageComponent = ({ imageSrc }) => {
    const handleError = (e) => {
      e.target.src = "/assets/products/Default.png"; // Set the fallback image source
    };
  
    return (
      <div>
        <img
          className="product-img"
          src={imageSrc}
          onError={handleError}
        />
        </div>

    );
  };
  
  export default ImageComponent;
  